import React from 'react';

import {
    Box, Grid, List, ListItem, ListItemIcon,
    ListItemSecondaryAction, ListItemText,
    ListSubheader, Paper, Switch,
} from '@material-ui/core';

import {
    Chat as ChatIcon,
    FreeBreakfast as FreeBreakfastIcon,
    MailOutline as MailOutlineIcon,
} from '@material-ui/icons';

import ResponsiveLayout from '../../Layouts/ResponsiveLayout';

const Settings = (props) => {
    return (
        <ResponsiveLayout>
            <Grid container component="main">
                <Grid item xs={12} sm={12} md={12} lg={6} xl={6} component={Paper} elevation={2} square>
                    <Box mb={2} p={1}>

                        {/* <ListHeader>Master Settings</ListHeader> */}
                        <List subheader={<ListSubheader>Master Settings</ListSubheader>}>
                            <ListItem>
                                <ListItemIcon>
                                    <MailOutlineIcon />
                                </ListItemIcon>
                                <ListItemText id="switch-list-label-wifi" primary="Users can receive email notifications" />
                                <ListItemSecondaryAction>
                                    <Switch
                                        edge="end"
                                        // onChange={handleToggle('wifi')}
                                        // checked={checked.indexOf('wifi') !== -1}
                                        color={'primary'}
                                        inputProps={{ 'aria-labelledby': 'switch-list-label-wifi' }}
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemIcon>
                                    <ChatIcon />
                                </ListItemIcon>
                                <ListItemText id="switch-list-label-bluetooth" primary="Allow post comments" />
                                <ListItemSecondaryAction>
                                    <Switch
                                        edge="end"
                                        // onChange={handleToggle('bluetooth')}
                                        // checked={checked.indexOf('bluetooth') !== -1}
                                        color={'primary'}
                                        inputProps={{ 'aria-labelledby': 'switch-list-label-bluetooth' }}
                                    />
                                </ListItemSecondaryAction>
                            </ListItem>
                            <ListItem>
                                <ListItemIcon>
                                    <FreeBreakfastIcon />
                                </ListItemIcon>
                                <ListItemText id="switch-list-label-bluetooth" primary="Other Settings (Coming Soon)" />
                                {/* <ListItemSecondaryAction>
                                    <Switch
                                        edge="end"
                                        // onChange={handleToggle('bluetooth')}
                                        // checked={checked.indexOf('bluetooth') !== -1}
                                        color={'primary'}
                                        inputProps={{ 'aria-labelledby': 'switch-list-label-bluetooth' }}
                                    />
                                </ListItemSecondaryAction> */}
                            </ListItem>
                        </List>
                    </Box>
                </Grid>
            </Grid>
        </ResponsiveLayout>
    );
}

export default Settings;